export interface IFitMapOption {
    value: boolean
}

export interface ICenter {
    lat: number,
    lng: number
}

export enum ExternalSourceOption {
    None = 1,
    ATMs,
    SharedBranches
}

export interface ILocationType {
    Id: string,
    Title: string,
    BackgroundColor: string,
    TextColor: string,
    ImageUrl: string,
    ImageAlt: string,
    ExternalSource: ExternalSourceOption,
    Base64Icon?: string,
    Selected?: boolean
}

export interface ICustomFilter {
    Id: string,
    Title: string,
    BackgroundColor: string,
    TextColor: string,
    Selected?: boolean
}

export type IManagerCallback<T> = (manager: T ) => void

export interface IConfiguration {
    SbEnable: boolean,
    SbZipCode: string,
    SbMaxRadius: number,
    SbOurBranchIcon: boolean,
    SbOurBranchBackground: string,
    SbOurBranchText: string,
    SbAtmIcon: boolean,
    SbAtmBackground: string,
    SbAtmText: string,
    SbBranchIcon: boolean,
    SbBranchBackground: string,
    SbBranchText: string,
    SbCoopEnable: boolean,
    SbCoopEnableBetaKey: boolean,
    SbCoopBetaKey: string,
    SbCoopEnableProdKey: boolean,
    SbCoopProductionKey: string,
    SbBetaEndpoint: string,
    SbProductionEndpoint: string
}

export interface ILocation extends SbLocation {
    Title?: string,
    DisplayName?: string,
    LocationType?: ILocationType,
    Street?: string;
    CustomFilters?: ICustomFilter[],
    Details?: string,
    Hours?: string
}

export interface ILocationMarker extends ILocation {
    Url?: string,
    Distance: number,
    PinIcon: string | null,
    PinBackground: string,
    PinBorder: string,
    Base64PinIcon?: string | null
}

export interface IExternalSource {
    ATM: ILocationMarker[],
    SharedBranch: ILocationMarker[]
}

interface ResultInfo {
    RecordType: string,
    Map: string,
    Error: string,
    RecordTotal: string,
    OriginName: string,
    OriginAddress: string,
    OriginCity: string,
    OriginState: string,
    OriginPostal: string,
    OriginLat: string,
    OriginLong: string,
    MapZoom: string,
    MapIcon: string,
    OriginCountry: string,
    SecureMap: string,
}

interface SbLocation {
    Id: string,
    InstitutionName: string,
    InstitutionRtn: string,
    TerminalId: string,
    RetailOutlet: string,
    LocatorType: string,
    Longitude: number | string,
    Latitude: number | string,
    Distance: number,
    Address: string,
    City: string,
    County: string,
    StateAbbreviation: string,
    State: string,
    Zip: string,
    Zip4: string,
    CountryAbbreviation: string,
    Country: string,
    Countryname: string,
    WebAddress: string,
    Phone: string,
    Fax: string,
    InstallationType: string,
    Hours_open_value: string,
    Comment: string,
    AccessNote: string,
    MondayOpen: string,
    MondayClose: string,
    TuesdayOpen: string,
    TuesdayClose: string,
    WednesdayOpen: string,
    WednesdayClose: string,
    ThursdayOpen: string,
    ThursdayClose: string,
    FridayOpen: string,
    FridayClose: string,
    SaturdayOpen: string,
    SaturdayClose: string,
    SundayOpen: string,
    SundayClose: string,
    MondayDriveThruOpen: string,
    MondayDriveThruClose: string,
    TuesdayDriveThruOpen: string,
    TuesdayDriveThruClose: string,
    WednesdayDriveThruOpen: string,
    WednesdayDriveThruClose: string,
    ThursdayDriveThruOpen: string,
    ThursdayDriveThruClose: string,
    FridayDriveThruOpen: string,
    FridayDriveThruClose: string,
    SaturdayDriveThruOpen: string,
    SaturdayDriveThruClose: string,
    SundayDriveThruOpen: string,
    SundayDriveThruClose: string,
    Open24Hours: string,
    WalkUp: string,
    DriveThru: string,
    HoursAvailable: string,
    Access: string,
    HandicapAccess: string,
    RestrictedAccess: string,
    AcceptDeposit: string,
    AcceptCash: string,
    EnvelopeRequired: string,
    Publish: string,
    Surcharge: string,
    OnMilitaryBase: string,
    OnPremise: string,
    Cashless: string,
    DriveThruOnly: string,
    SecondaryStructure: string,
    LimitedTransactions: string,
    MilitaryIdRequired: string,
    SelfServiceDevice: string,
    SelfServiceOnly: string,
    CuForKids: string,
    DisplayCU: string,
    VCom: string,
    SingleMap: string
}

export interface IProximityResponse {
    ResultInfo: ResultInfo,
    Locations: SbLocation[]
}

export interface ILocationFinderProps {
    apiKey: string;
    center?: ICenter;
    config: IConfiguration;
    cssClass: string;
    detailsUrl: string;
    locations: ILocation[];
    locationTypes: ILocationType[];
    customFilters: ICustomFilter[];
    zoom: number;
    filterType: string;
    enableDetails: boolean;
}
